export enum AuthenticationStatus {
  PENDING = 0,
  SUCCESS = 1,
  FAILED = 2,
  ERROR = 3,
  EXPIRED = 4
}
